import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "@utils/api";

import { ROLES } from "@constants/index";

import { labQKeys } from "@hooks/queries/lab/queryKeys";
import { timelineQKeys } from "@hooks/queries/timeline/queryKeys";

import { useAuth } from "@contexts/auth";

interface MutationProps {
  labId: string;
  patientId: string;
}

export const useDeleteLab = () => {
  const queryClient = useQueryClient();
  const { roles , can } = useAuth();
  const isAdmin = can("labs.delete");

  return useMutation({
    mutationFn: ({ labId }: MutationProps) => {
      return api.delete(`lab/${isAdmin ? "delete" : "archive"}/${labId}`);
    },
    onSuccess: (_, variables) => {
      queryClient.invalidateQueries({
        queryKey: labQKeys.patient(variables.patientId),
      });
      queryClient.invalidateQueries({
        queryKey: timelineQKeys.patient(variables.patientId),
      });
    },

    onError: (res: any) => {
      console.error("[From Delete Lab]", res);
    },
  });
};
